import { Flex, type FlexProps, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNewBadgeStyles } from '~/components/shared/componentStyles/NewBadge.style'

export const NewBadge = (props: FlexProps) => {
  const { t } = useTranslation()
  const styles = useNewBadgeStyles()
  return (
    <Flex css={styles.container} {...props}>
      <Flex css={styles.contentContainer}>
        <Text css={styles.text}>{t('baseSettings.new')}</Text>
      </Flex>
    </Flex>
  )
}
